import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagValidarTokenEscritorioFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagValidarTokenEscritorio'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagValidarTokenEscritorio'
          label='Validar token escritorio'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagValidarTokenEscritorioFormGroup)
